import { ThemeProperties } from '../../../core';

export interface InputTheme {
	baseBorderColor: string;
	basePaddingHorizontal: string;
	basePaddingVertical: string;
	baseFont: string;
	baseTextColor: string;
	baseBorderRadius: string;
	baseBackground: string;
	baseMinHeight: string;

	focusRingColor: string;

	hoverBorderColor: string;

	readOnlyBackground: string;
	readOnlyBorderColor: string;

	placeholderTextColor: string;

	invalidBorderColor: string;

	iconPaddingLeft: string;
	iconColor: string;
	iconSize: string;
	iconFocusRingColor: string;
}
export const theme = new ThemeProperties('input');
